import { Box, BoxProps, SxProps, Theme } from "@mui/material";
import { ReactNode, forwardRef } from "react";

export interface AppPopoverContentProps {
  /** If `true`, default styles are used. Pass `false` to don't use any styles or provide your own styles.
   * @default true
   */
  isUseDefaultStyles?: boolean;
  /** Makes the wrapper invisible so the children use their own styles. */
  isTransparent?: boolean;
  sx?: SxProps<Theme>;
  children: ReactNode;
  onClick?: BoxProps["onClick"];
}

/** Wraps the content of popover. Provides default styling. */
export default forwardRef<HTMLDivElement, AppPopoverContentProps>(function AppPopoverContent(
  {
    isUseDefaultStyles = true,
    isTransparent = false,
    sx,
    children,
    onClick,
  }: AppPopoverContentProps,
  ref,
) {
  return (
    <Box
      ref={ref}
      data-testid='AppPopoverContent'
      sx={{
        ...(isUseDefaultStyles
          ? {
              maxWidth: { xxs: "95vw" },
              maxHeight: { xxs: "95vh" },
              overflow: "auto",
              py: 1,
              px: 2,
            }
          : undefined),
        ...(isTransparent
          ? {
              background: "transparent",
              border: "none",
              borderWidth: 0,
              boxShadow: "none",
            }
          : undefined),
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
});
